import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShippingCostService {

  constructor() {
    
  }

  getPriceOfShipping(shipping, subtotal) {
    if (!shipping)
      return 0;
    if (shipping['percentuale'] === 0) {
        return shipping['prezzo'];
    }
    else {
      return subtotal * shipping['percentuale'] / 100;
    }
  }

  getEstimatedTime(shipping) {
    let time = shipping['lead_time_spedizione'];
    if (time == 0)
      return;
    return time == 1 ? '1 ora' : time + ' ore';
  }
}
